module.exports = __webpack_public_path__ + "static/media/huck-analysis.6f011f31.MOV";